interface Props {
    direction: 'ASC' | 'DESC';
    onClick: (dir: 'ASC' | 'DESC') => void;
    labelLeft?: string;
    labelRight?: string;
};

const Order = ({direction, onClick, labelLeft, labelRight}: Props) => {
    const color = {
        ASC: {
            top: 'text-color-dark',
            bottom: 'text-color-gray'
        },
        DESC: {
            top: 'text-color-gray',
            bottom: 'text-color-dark'
        }
    }

    const dir = direction === 'ASC' ? 'DESC' : 'ASC';


    return (
        <div className="flex items-center margin-right-5 gap-4 cursor-pointer" onClick={() => onClick(dir)}>
            {labelLeft ? <span className="">{labelLeft}</span>: null}
            <div className="flex flex-column">
                <span className={`rioglyph rioglyph-triangle-top cursor-pointer ${color[direction].top} text-size-14`}></span>
                <span className={`rioglyph rioglyph-triangle-bottom cursor-pointer ${color[direction].bottom} text-size-14`}></span>
            </div>
            {labelRight ? <span className="">{labelRight}</span>: null}
        </div>
    )
}

export default Order;